import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col, Row, Button } from 'reactstrap';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD, OPORTUNIDADES_STATE_SECTION_MAP } from 'CONST';
import { patch } from 'helpers/requests';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Prompt } from 'react-router-dom';
import useExitPrompt from 'components/shared/useExitPrompt';
import NewFileTable from '../shared/NewFileTable';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';
import OportunidadesFormAccordion from './OportunidadesFormAccordion';
import VentaEnVerdeSeccionAdjuntos from './VentaEnVerdeSeccionAdjuntos';
import AduanerasSeccionAdjuntos from './AduanerasSeccionAdjuntos';
import VeedoresSeccionAdjuntos from './VeedoresSeccionAdjuntos';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';

const CompletarInformacionSection = ({
  fullData,
  setFullData,
  setInitialSection,
  id,
  estadosOportunidad,
}) => {
  const dataAdjuntos = {
    cuadros_de_obras: {
      label: 'Cuadros de obras',
      adjunto_docs: 'cuadros_de_obras_docs',
    },
    balance_inmobiliario: {
      label: 'Balance Inmobiliario',
      adjunto_docs: 'balance_inmobiliario_docs',
    },
    contratos_vigentes: {
      label: 'Contratos Vigentes',
      adjunto_docs: 'contratos_vigentes_docs',
    },
    experiencia_acreditable: {
      label: 'Experiencia Acreditable',
      adjunto_docs: 'experiencia_acreditable_docs',
    },
    estado_situacion_socios: {
      label: 'Estado Situación Socios',
      adjunto_docs: 'estado_situacion_socios_docs',
    },
    consulta_unificada_poder_judicial: {
      label: 'Consulta Unificada Poder Judicial ',
      adjunto_docs: 'consulta_unificada_poder_judicial_docs',
    },
  };

  const requisitosEmision = {
    abono_prima: {
      label: 'Abono Prima',
      adjunto_docs: 'abono_prima_docs',
    },
    analisis_uaf: {
      label: 'Análisis UAF',
      adjunto_docs: 'analisis_uaf_docs',
    },
    constitucion_empresa: {
      label: 'Constitucion Empresa y Poderes Vigentes',
      adjunto_docs: 'constitucion_empresa_docs',
    },
    ficha_cliente: {
      label: 'Ficha Cliente',
      adjunto_docs: 'ficha_cliente_docs',
    },
    carpeta_tributaria: {
      label: 'Carpeta Tributaria',
      adjunto_docs: 'carpeta_tributaria_docs',
    },
    evaluacion_infocred_sinacofi: {
      label: 'Evaluación Infocred y Sinacofi',
      adjunto_docs: 'evaluacion_infocred_sinacofi_docs',
    },
    boletin_comercial_dicom: {
      label: 'Boletín Comercial DICOM',
      adjunto_docs: 'boletin_comercial_dicom_docs',
    },
    eerr_balance_2_ultimos_periodos: {
      label: 'EERR y Balance 2 Últimos periódos',
      adjunto_docs: 'eerr_balance_2_ultimos_periodos_docs',
    },
    prebalance: {
      label: 'Prebalance',
      adjunto_docs: 'prebalance_docs',
    },
  };

  const emptyAdjuntos = {
    cuadros_de_obras: [],
    balance_inmobiliario: [],
    contratos_vigentes: [],
    experiencia_acreditable: [],
    estado_situacion_socios: [],
    consulta_unificada_poder_judicial: [],
    venta_en_verde_cuestionario: [],
    venta_en_verde_permiso_edificacion: [],
    venta_en_verde_aprobacion_bancaria: [],
    aduaneras_ficha_cliente: [],
    aduaneras_bce: [],
    veedores_liquidaciones_ficha: [],
    veedores_liquidaciones_bce: [],
    veedores_liquidaciones_nombramiento: [],
    veedores_liquidaciones_cv: [],
    veedores_liquidaciones_estado_situacion_admin_ficha: [],
    veedores_liquidaciones_estado_situacion_admin_bce: [],
    abono_prima: [],
    analisis_uaf: [],
    constitucion_empresa: [],
    ficha_cliente: [],
    carpeta_tributaria: [],
    evaluacion_infocred_sinacofi: [],
    boletin_comercial_dicom: [],
    eerr_balance_2_ultimos_periodos: [],
    prebalance: [],
  };

  const emptyAdjuntosDocs = {
    cuadros_de_obras_docs: [],
    balance_inmobiliario_docs: [],
    contratos_vigentes_docs: [],
    experiencia_acreditable_docs: [],
    estado_situacion_socios_docs: [],
    consulta_unificada_poder_judicial_docs: [],
    venta_en_verde_cuestionario_docs: [],
    venta_en_verde_permiso_edificacion_docs: [],
    venta_en_verde_aprobacion_bancaria_docs: [],
    aduaneras_ficha_cliente_docs: [],
    aduaneras_bce_docs: [],
    veedores_liquidaciones_ficha_docs: [],
    veedores_liquidaciones_bce_docs: [],
    veedores_liquidaciones_nombramiento_docs: [],
    veedores_liquidaciones_cv_docs: [],
    veedores_liquidaciones_estado_situacion_admin_ficha_docs: [],
    veedores_liquidaciones_estado_situacion_admin_bce_docs: [],
    abono_prima_docs: [],
    analisis_uaf_docs: [],
    constitucion_empresa_docs: [],
    ficha_cliente_docs: [],
    carpeta_tributaria_docs: [],
    evaluacion_infocred_sinacofi_docs: [],
    boletin_comercial_dicom_docs: [],
    eerr_balance_2_ultimos_periodos_docs: [],
    prebalance_docs: [],
  };

  const [newAntecedentes, setNewAntecedentes] = useState(emptyAdjuntos);
  const [oldAntecedentes, setOldAntecedentes] = useState(emptyAdjuntosDocs);

  const [editableSection, setEditableSection] = useState(false);

  const [adjuntosEliminados, setAdjuntosEliminados] = useState([]);

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isFormSaved, setIsFormSaved] = useState(true);

  const editableStates = [ESTADOS_OPORTUNIDAD.informacionInicialValidada];

  useEffect(() => {
    if (fullData && fullData.antecedentes) {
      setOldAntecedentes(fullData.antecedentes);
    }
    if (fullData && fullData.estado && editableStates.includes(fullData.estado.nemotecnico)) {
      setEditableSection(true);
    }
  }, [fullData]);

  const getBodyDocs = () => {
    return {
      cuadros_de_obras: newAntecedentes.cuadros_de_obras.map((d) => d.uuid),
      balance_inmobiliario: newAntecedentes.balance_inmobiliario.map((d) => d.uuid),
      contratos_vigentes: newAntecedentes.contratos_vigentes.map((d) => d.uuid),
      experiencia_acreditable: newAntecedentes.experiencia_acreditable.map((d) => d.uuid),
      estado_situacion_socios: newAntecedentes.estado_situacion_socios.map((d) => d.uuid),
      consulta_unificada_poder_judicial: newAntecedentes.consulta_unificada_poder_judicial.map(
        (d) => d.uuid,
      ),
      venta_en_verde_cuestionario: newAntecedentes.venta_en_verde_cuestionario.map((d) => d.uuid),
      venta_en_verde_permiso_edificacion: newAntecedentes.venta_en_verde_permiso_edificacion.map(
        (d) => d.uuid,
      ),
      venta_en_verde_aprobacion_bancaria: newAntecedentes.venta_en_verde_aprobacion_bancaria.map(
        (d) => d.uuid,
      ),
      aduaneras_ficha_cliente: newAntecedentes.aduaneras_ficha_cliente.map((d) => d.uuid),
      aduaneras_bce: newAntecedentes.aduaneras_bce.map((d) => d.uuid),
      veedores_liquidaciones_ficha: newAntecedentes.veedores_liquidaciones_ficha.map((d) => d.uuid),
      veedores_liquidaciones_bce: newAntecedentes.veedores_liquidaciones_bce.map((d) => d.uuid),
      veedores_liquidaciones_nombramiento: newAntecedentes.veedores_liquidaciones_nombramiento.map(
        (d) => d.uuid,
      ),
      veedores_liquidaciones_cv: newAntecedentes.veedores_liquidaciones_cv.map((d) => d.uuid),
      veedores_liquidaciones_estado_situacion_admin_ficha: newAntecedentes.veedores_liquidaciones_estado_situacion_admin_ficha.map(
        (d) => d.uuid,
      ),
      veedores_liquidaciones_estado_situacion_admin_bce: newAntecedentes.veedores_liquidaciones_estado_situacion_admin_bce.map(
        (d) => d.uuid,
      ),
      abono_prima: newAntecedentes.abono_prima.map((d) => d.uuid),
      analisis_uaf: newAntecedentes.analisis_uaf.map((d) => d.uuid),
      constitucion_empresa: newAntecedentes.constitucion_empresa.map((d) => d.uuid),
      ficha_cliente: newAntecedentes.ficha_cliente.map((d) => d.uuid),
      carpeta_tributaria: newAntecedentes.carpeta_tributaria.map((d) => d.uuid),
      evaluacion_infocred_sinacofi: newAntecedentes.evaluacion_infocred_sinacofi.map((d) => d.uuid),
      boletin_comercial_dicom: newAntecedentes.boletin_comercial_dicom.map((d) => d.uuid),
      eerr_balance_2_ultimos_periodos: newAntecedentes.eerr_balance_2_ultimos_periodos.map(
        (d) => d.uuid,
      ),
      prebalance: newAntecedentes.prebalance.map((d) => d.uuid),
    };
  };

  const deleteAdjunto = () => {
    patch(
      `${BASE_URL}${API.antecedentes}${oldAntecedentes.id}/borrar-adjunto/`,
      adjuntosEliminados,
    ).then((response) => {
      setOldAntecedentes(response);
      setAdjuntosEliminados([]);
    });
  };

  const actualizarOportunidad = () => {
    const bodyDocs = getBodyDocs();
    setLoading(true);
    patch(`${BASE_URL}${API.antecedentes}${oldAntecedentes.id}/`, bodyDocs)
      .then((response) => {
        setNewAntecedentes(emptyAdjuntos);
        setOldAntecedentes(response);
        setIsFormSaved(true);
        setShowUpdateModal(true);
        if (adjuntosEliminados.length) deleteAdjunto();
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const avanzarOportunidad = () => {
    const bodyDocs = getBodyDocs();
    setLoading(true);
    patch(`${BASE_URL}${API.antecedentes}${oldAntecedentes.id}/`, bodyDocs)
      .then((response) => {
        setOldAntecedentes(response);
        setNewAntecedentes(emptyAdjuntos);
        setIsFormSaved(true);
        const body = {
          estado_id: estadosOportunidad.find(
            (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.informacionCompletadaEsperandoSuscriptor,
          ).id,
        };
        if (adjuntosEliminados.length) deleteAdjunto();
        patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
          .then((responseOportunidad) => {
            setFullData(responseOportunidad);
            setInitialSection(
              OPORTUNIDADES_STATE_SECTION_MAP[responseOportunidad.estado.nemotecnico],
            );
            setEditableSection(false);
            setShowUpdateModal(true);
          })
          .catch(() => {
            setShowErrorModal(true);
          });
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setConfirmationModal(false);
        setLoading(false);
      });
  };

  const removeAdjunto = (idDoc, tipoDoc) => {
    setAdjuntosEliminados((prevState) => [...prevState, [idDoc, tipoDoc]]);
  };

  useExitPrompt((e) => {
    e.preventDefault();
    e.returnValue = '';
  }, !isFormSaved);

  const sections = [
    {
      name: 'Venta en Verde',
      component: (
        <VentaEnVerdeSeccionAdjuntos
          newAntecedentes={newAntecedentes}
          oldAntecedentes={oldAntecedentes}
          setNewAntecedentes={setNewAntecedentes}
          setOldAntecedentes={setOldAntecedentes}
          removeAdjunto={removeAdjunto}
          editableSection={editableSection}
          setIsFormSaved={setIsFormSaved}
        />
      ),
      collapsed: true,
      isValid: true,
      hasIcon: false,
      expansible: true,
      isVisible: true,
    },
    {
      name: 'Aduaneras',
      component: (
        <AduanerasSeccionAdjuntos
          newAntecedentes={newAntecedentes}
          oldAntecedentes={oldAntecedentes}
          setNewAntecedentes={setNewAntecedentes}
          setOldAntecedentes={setOldAntecedentes}
          removeAdjunto={removeAdjunto}
          editableSection={editableSection}
          setIsFormSaved={setIsFormSaved}
        />
      ),
      collapsed: true,
      isValid: true,
      hasIcon: false,
      expansible: true,
      isVisible: true,
    },
    {
      name: 'Veedores y Liquidaciones',
      component: (
        <VeedoresSeccionAdjuntos
          newAntecedentes={newAntecedentes}
          oldAntecedentes={oldAntecedentes}
          setNewAntecedentes={setNewAntecedentes}
          setOldAntecedentes={setOldAntecedentes}
          removeAdjunto={removeAdjunto}
          editableSection={editableSection}
          setIsFormSaved={setIsFormSaved}
        />
      ),
      collapsed: true,
      isValid: true,
      hasIcon: false,
      expansible: true,
      isVisible: true,
    },
  ];

  return (
    <div>
      <FormGroup>
        {Object.keys(dataAdjuntos).map((key) => {
          return (
            <div key={key}>
              <Row>
                <Col>
                  <Label>{dataAdjuntos[key].label}</Label>
                </Col>
                <Col>
                  <NewFileTable
                    handleAdd={(file) => {
                      setIsFormSaved(false);
                      setNewAntecedentes((prevState) => ({
                        ...prevState,
                        [key]: [...prevState[key], file],
                      }));
                    }}
                    handleDeleteNew={(file) => {
                      setIsFormSaved(false);
                      setNewAntecedentes((prevState) => ({
                        ...prevState,
                        [key]: prevState[key].filter((doc) => doc.uuid !== file.uuid),
                      }));
                    }}
                    handleDelete={(event) => {
                      setIsFormSaved(false);
                      removeAdjunto(event.id, key);
                      setOldAntecedentes((prevState) => ({
                        ...prevState,
                        [dataAdjuntos[key].adjunto_docs]: prevState[
                          dataAdjuntos[key].adjunto_docs
                        ].filter((doc) => doc.id !== event.id),
                      }));
                    }}
                    uploadUrl={`${BASE_URL}${API.upload}/`}
                    downloadUrl={`${BASE_URL}${API.download}/`}
                    newFiles={newAntecedentes[key]}
                    fileList={oldAntecedentes[dataAdjuntos[key].adjunto_docs]}
                    individualMaxFileSize={13}
                    globalMaxFileSize={20}
                    loginIdToken=""
                    readOnly={!editableSection}
                  />
                </Col>
              </Row>
              <br />
            </div>
          );
        })}
        <hr style={{ marginTop: 40, marginBottom: 40 }} />
        <OportunidadesFormAccordion sections={sections} hasIcons={false} />
        <hr style={{ marginTop: 40, marginBottom: 40 }} />
        <Label>
          <strong> Requisitos de Emisión </strong>
        </Label>
        {Object.keys(requisitosEmision).map((key) => {
          return (
            <div key={key}>
              <Row>
                <Col>
                  <Label>{requisitosEmision[key].label}</Label>
                </Col>
                <Col>
                  <NewFileTable
                    handleAdd={(file) => {
                      setIsFormSaved(false);
                      setNewAntecedentes((prevState) => ({
                        ...prevState,
                        [key]: [...prevState[key], file],
                      }));
                    }}
                    handleDeleteNew={(file) => {
                      setIsFormSaved(false);
                      setNewAntecedentes((prevState) => ({
                        ...prevState,
                        [key]: prevState[key].filter((doc) => doc.uuid !== file.uuid),
                      }));
                    }}
                    handleDelete={(event) => {
                      setIsFormSaved(false);
                      removeAdjunto(event.id, key);
                      setOldAntecedentes((prevState) => ({
                        ...prevState,
                        [requisitosEmision[key].adjunto_docs]: prevState[
                          requisitosEmision[key].adjunto_docs
                        ].filter((doc) => doc.id !== event.id),
                      }));
                    }}
                    uploadUrl={`${BASE_URL}${API.upload}/`}
                    downloadUrl={`${BASE_URL}${API.download}/`}
                    newFiles={newAntecedentes[key]}
                    fileList={oldAntecedentes[requisitosEmision[key].adjunto_docs]}
                    individualMaxFileSize={13}
                    globalMaxFileSize={20}
                    loginIdToken=""
                    readOnly={!editableSection}
                  />
                </Col>
              </Row>
              <br />
            </div>
          );
        })}
      </FormGroup>
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            className="btn btn-secondary white"
            style={{ marginRight: 25 }}
            onClick={() => actualizarOportunidad()}
            disabled={loading || confirmationModal}
          >
            {loading && !confirmationModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Guardar Información Temporalmente'
            )}
          </Button>
          <Button
            className="btn btn-secondary blue"
            onClick={() => setConfirmationModal(true)}
            disabled={loading || confirmationModal}
          >
            {loading && confirmationModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Guardar Información y Avanzar'
            )}
          </Button>
        </div>
      )}
      <CheckModal
        isOpen={showUpdateModal}
        toggle={() => setShowUpdateModal(false)}
        handleOk={() => setShowUpdateModal(false)}
        okBtnText="OK"
        confirmMsg="Informacion guardada exitosamente."
      />
      <AvanzarOportunidadConfirmationModal
        openModal={confirmationModal}
        setOpenModal={setConfirmationModal}
        avanzarOportunidad={avanzarOportunidad}
        loading={loading}
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleClearError={() => setShowErrorModal(false)}
        errorMsg="Ha ocurrido un error al actualizar la oportunidad."
        loading={false}
        onlyCancelButton
      />
      <Prompt
        when={!isFormSaved}
        message="¿Está seguro que desea salir? Es posible que los cambios no se guarden."
      />
    </div>
  );
};

CompletarInformacionSection.propTypes = {
  id: PropTypes.string,
  fullData: PropTypes.shape({
    antecedentes: PropTypes.shape({
      id: PropTypes.number,
    }),
    actualizacion_ts: PropTypes.string,
    afianzado: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      rut: PropTypes.string,
    }),
    afianzado_id: PropTypes.number,
    creacion_ts: PropTypes.string,
    estado: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    monto: PropTypes.number,
    responsable_id: PropTypes.number,
    suscriptor_id: PropTypes.number,
  }),
  setFullData: PropTypes.func.isRequired,
  setInitialSection: PropTypes.func.isRequired,
  estadosOportunidad: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      descripcion: PropTypes.string,
    }),
  ),
};

CompletarInformacionSection.defaultProps = {
  fullData: null,
  id: null,
  estadosOportunidad: [],
};

export default CompletarInformacionSection;
